/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, amount: NonNullable<unknown> }} Plan_Change_Trial_NoteInputs */

const en_plan_change_trial_note = /** @type {(inputs: Plan_Change_Trial_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nothing due today. Your trial still ends ${i?.date}; your first charge will be ${i?.amount}.`)
};

const es_plan_change_trial_note = /** @type {(inputs: Plan_Change_Trial_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No hay nada que pagar hoy. Tu prueba sigue terminando el ${i?.date}; tu primer cargo será de ${i?.amount}.`)
};

/**
* | output |
* | --- |
* | "Nothing due today. Your trial still ends {date}; your first charge will be {amount}." |
*
* @param {Plan_Change_Trial_NoteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_change_trial_note = /** @type {((inputs: Plan_Change_Trial_NoteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Change_Trial_NoteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_change_trial_note(inputs)
	return en_plan_change_trial_note(inputs)
});